export default "__VITE_ASSET__BF08qtxn__"